module.exports = __webpack_public_path__ + "0567a4e2d280b3f5ec0a383e24b422bf.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/2000_r_50.mp3
// module id = 424
// module chunks = 0